export default __webpack_public_path__ + "static/media/not-found.a731c623.png";